export default __webpack_public_path__ + "static/media/emmanuel.3970713d.jpg";